import { format } from '@eversports/dates'

export function getQuarter(date: Date): 1 | 2 | 3 | 4 {
  const monthQuarter = Number(format(date, 'Q'))
  if (monthQuarter === 1 || monthQuarter === 2 || monthQuarter === 3 || monthQuarter === 4) {
    return monthQuarter
  }
  throw new Error('Invalid quarter calculated')
}
